import type { Player } from '../types/gameTypes';
import { initialsOf } from '../lib/format';

// Compact coloured dot used in lists/tables.
export const PlayerDot = ({ player, className = 'h-2.5 w-2.5' }: { player: Player; className?: string }) => (
  <span
    className={`inline-block rounded-full ${className}`}
    style={{ backgroundColor: player.color, opacity: player.isBankrupt ? 0.35 : 1 }}
    aria-hidden
  />
);

// Round board avatar (pawn) with player initials.
export const PlayerPawn = ({
  player,
  isActive = false,
  isStepping = false,
}: {
  player: Player;
  isActive?: boolean;
  isStepping?: boolean;
}) => (
  <span
    title={`${player.name}${player.isBankrupt ? ' (bankrupt)' : ''}`}
    className={`flex h-6 w-6 items-center justify-center rounded-full border text-[9px] font-bold text-slate-950 shadow-lg transition ${
      isActive ? 'scale-110 border-white/90' : 'border-slate-950/60'
    } ${isStepping ? 'pawn-hop' : ''} ${player.isBankrupt ? 'opacity-30 outline-1 outline-rose-400/80' : ''}`}
    style={{ backgroundColor: player.color }}
  >
    {initialsOf(player.name)}
  </span>
);